import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Content from "@/components/Content.vue";
import Divider from "@/components/Divider.vue";
import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import Heading from "@/components/Heading.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Retreat2025View',
  setup(__props) {

document.title = 'TSG R&D Retreat 2025 &bullet; tsgroup.space'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, { subtitle: "Berlin, Germany" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("TSG R&D Retreat 2025")
      ])),
      _: 1,
      __: [0]
    }),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode(" Soon ... ")
      ])),
      _: 1,
      __: [1]
    })
  ], 64))
}
}

})